import './gantasoft.css'
import React, { useState } from 'react'
import Hero from './hero/hero';
import Service from './services/services';
import About from './about/about';
import Contact from './contact/contact';
import Footer from './footer/footer';
import Header from './header/header';
import Features from './about/features';
import PricingTable from './pricing/pricing';
import Projects from './projects/projects';
import SupportTicketForm from './supportform/support';
import { Routes,Route } from 'react-router-dom';
import NotFoundPage from './notfound/notfound';
import ProjectDetailss from './projects/projectdetails';

const GantasoftApp = () => {

        const [playState, setPlayState] = useState(false);

        return (
                <div>
                        <Header />
                        <Routes> 
                                <Route exact path="/technical-support" element={<SupportTicketForm />}>  </Route>
                             
                                <Route exact path="/projects" element={<ProjectDetailss />}>  </Route>
                                 <Route path="/" element={  <>
                                  <Hero /> 
                                  <Service /> 
                                  <PricingTable /> 
                                  <Projects /> 
                                  <About /> 
                                  <Features />
                                   <Contact />
                                   </>}>
                               
                                    </Route>
                                    <Route  path="*" element={NotFoundPage}>  </Route>
                       </Routes>
                      
                        <Footer />
                        {/* <!-- Scroll Top --> */}
                        <a href="#" id="scroll-top" class="scroll-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

                </div>)
}
export default GantasoftApp